__turbopack_context__.v({
  "bg": "CtaSection-module-scss-module__TVaoiq__bg",
  "body": "CtaSection-module-scss-module__TVaoiq__body",
  "body--long-cta": "CtaSection-module-scss-module__TVaoiq__body--long-cta",
  "content": "CtaSection-module-scss-module__TVaoiq__content",
  "cta": "CtaSection-module-scss-module__TVaoiq__cta",
  "image": "CtaSection-module-scss-module__TVaoiq__image",
  "image-wrapper": "CtaSection-module-scss-module__TVaoiq__image-wrapper",
  "main": "CtaSection-module-scss-module__TVaoiq__main",
  "pattern": "CtaSection-module-scss-module__TVaoiq__pattern",
  "wrapper": "CtaSection-module-scss-module__TVaoiq__wrapper",
});
